import { notify } from "@general-backoffice/core";
import Header from "@general-backoffice/core/lib/pages/auth/components/Header";
import { messagingConsentsEndpoints } from "@investhinks/api-client";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, useSearchParams } from "react-router-dom";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";

import getErrorMessage from "../../../utils/getErrorMessage";

const ConfirmNewsletterUnsubscription: React.FC = () => {
  const { t } = useTranslation("auth", { keyPrefix: "confirmNewsletterUnsubscription" });
  const [searchParams] = useSearchParams();
  const [confirmed, setConfirmed] = useState(false);

  const email = searchParams.get("email");

  const confirmRemoval = () => {
    if (!email) return;
    messagingConsentsEndpoints
      .unsubscribe("NEWSLETTER_EMAILS", email)
      .then(() => {
        notify.success(t("unsubscribeSuccess"));
        setConfirmed(true);
      })
      .catch((e: unknown) => {
        notify.error(getErrorMessage(e, "Error"));
      });
  };

  if (!email) return <Navigate to="/" replace />;
  return (
    <React.Fragment>
      <Header title={t("headerTitle")} />
      <Container className="mt--9 pb-5">
        <Row className="justify-content-center">
          <Col lg="5" md="7">
            <Card className="bg-secondary border-0 mb-0">
              <CardBody className="px-lg-5 py-lg-5 text-center">
                {!confirmed ? (
                  <>
                    <p className="font-weight-bold">{t("unsubscribePrompt")}</p>
                    <Button color="danger" onClick={confirmRemoval}>
                      {t("unsubscribeButton")}
                    </Button>
                  </>
                ) : (
                  <p className="font-weight-bold mt-3">{t("unsubscribeSuccess")}</p>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default ConfirmNewsletterUnsubscription;
